<template>
    <div  class="cache-content">
        <div class="title">
            <span class="span">根据周期和入职时间生成人员当年应填报工时记录；定时任务自动执行</span><br/>
            <el-button type="primary" size="small" @click="handleQuery">执行</el-button>
        </div>
      <div class="title">
        <span class="span">针对所有工时明细对其添加消耗成本数据</span><br/>
        <el-button type="primary" size="small" @click="handleQueryDetail">执行</el-button>
      </div>
        <div class="title">
            <span class="span">统计项目消耗的所有成本并更新项目消耗成本字段</span><br/>
            <el-button type="primary" size="small" @click="handleQueryDate">执行</el-button>
        </div>
    </div>
</template>
<script>
export default {
  data() {
    return {

    };
  },
  mounted() {
  },
  methods: {
    handleQuery() {
      httpKit.post($api_pms.tools.healthGenerateSheet).then((res) => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
        } else if (res.data.code === '500') {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleQueryDate() {
      httpKit.post($api_pms.home.historicalProject).then((res) => {
        if (res.data.code === '200') {
          this.$message.success('成功');
        } else if (res.data.code === '500') {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleQueryDetail() {
      httpKit.post($api_pms.home.detailConsumeAdd).then((res) => {
        if (res.data.code === '200') {
          this.$message.success(res.data.msg);
        } else if (res.data.code === '500') {
          this.$message.error(res.data.msg);
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
  .span {
    font-size: 14px;
  }
  .cache-content{
    padding: 0;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
  }
  .title {
    background-color: #f2f2f2;
    width: calc(30% - 6px);
    margin: 8px 0;
    padding: 10px;
  }
  .ul {
    margin: 20px 0;
    li{
      list-style: none;
    }
  }
</style>
